import { makeAutoObservable } from "mobx";
import { SearchObject } from "app/common/Model/SearchObject";
import { toast } from "react-toastify";
import { PageResponse } from "app/common/Model/Shared";
import {
  pagingCheckInSync
} from "app/services/VisitService";
import { removeListCheckInToCrm } from "app/services/SyncCRMService";

export default class CheckInVoidedAsyncStore {
  searchCheckIn = {
    ...new SearchObject(),
    fromLastDateSync: new Date(new Date().setMonth(new Date().getMonth() - 1)),
    toLastDateSync: new Date(),
    currentDepName: null,
    isSyncedToCRM: false,
    voided: true
  };
  selectCheckInAsync = [];
  resetSelectedRows = false;
  pageCheckIn = new PageResponse();

  constructor() {
    makeAutoObservable(this);
  }

  pagingCheckIn = async () => {
    const { currentDepName, visitTypeCode, ...ortherData } = this.searchCheckIn;
    if (visitTypeCode) {
      ortherData.visitTypeCode = visitTypeCode?.code;
    }
    if (currentDepName) {
      ortherData.currentDepName = currentDepName?.id;
    }

    return await pagingCheckInSync({ ...ortherData })
      .then(({ data }) => {
        this.pageCheckIn = data;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu Checkin có lỗi");
      });
  };

  handleChangeFormSearch = (searchCheckIn) => {
    this.searchCheckIn = { ...this.searchCheckIn, ...searchCheckIn };

    this.pagingCheckIn();
  };

  setSelectCheckInAsync = (list) => {
    this.selectCheckInAsync = list;
  };

  removeListCheckInToCrm = async () => {
    const visitIds = this.selectCheckInAsync?.map((el) => el?.id);
    this.resetSelectedRows = !this.resetSelectedRows;

    return await removeListCheckInToCrm(visitIds)
      .then(({ data }) => {
        this.resetSelectedRows = !this.resetSelectedRows;
        this.selectCheckInAsync = [];

        if (Array.isArray(data)) {
          const successCount = data.length;
          const total = visitIds.length;
          if (successCount === total) {
            toast.success(`Đồng bộ Check In thành công: ${successCount}/${total} bản ghi`);
          } else if (successCount > 0) {
            toast.warning(`Đồng bộ Check In thành công một phần: ${successCount}/${total} bản ghi`);
          } else {
            //toast.error("Đồng bộ Check In thất bại toàn bộ");
            toast.error("Đồng bộ Check In thất bại");
          }
          this.pagingCheckIn();
          return data;
        } else {
          toast.error("Dữ liệu trả về từ API không hợp lệ");
          return [];
        }
      })
      .catch((error) => {
        this.resetSelectedRows = !this.resetSelectedRows;
        this.selectCheckInAsync = [];
        console.error(error);
        toast.error("Đồng bộ Check In có lỗi");
        return [];
      });
  };


  resetStore = () => {
    this.searchCheckIn = {
      ...new SearchObject(),
      fromLastDateSync: new Date(),
      toLastDateSync: new Date(new Date().setMonth(new Date().getMonth() - 1)),
    };
  };
}
